import React, { useCallback, useEffect, useMemo, useState } from "react";
import Modal, { Styles } from "react-modal";

import "./LeftSlider.styles.scss";
import { useLeftSliderSelector, useViewActions } from "../../../store";
import { LeftSliderType } from "../../../store/types";

type TSliderStatus = "default" | "open" | "close";

export const LeftSlider: React.FC = () => {
  const { setLeftSlider } = useViewActions();
  const [sliderStatus, setSliderStatus] = useState<TSliderStatus>("default");
  const [contentRef, setContentRef] = useState<HTMLDivElement | null>(null);
  const [overlayRef, setOverlayRef] = useState<HTMLDivElement | null>(null);

  useEffect(() => {
    if (overlayRef && sliderStatus === "close") {
      overlayRef.classList.add(`left-slider__overlay--${sliderStatus}`);
    } else {
      overlayRef?.classList.remove(`left-slider__overlay--${sliderStatus}`);
    }
  }, [sliderStatus]);

  const closeLeftSlider = useCallback(() => {
    setSliderStatus("close");
  }, []);

  const invalidate = useCallback(
    ({ animationName }: AnimationEvent) => {
      if (animationName === "left-slide-close") {
        setSliderStatus("default");
        contentRef?.removeEventListener("animationend", invalidate);
        setLeftSlider(null);
      }
    },
    [contentRef]
  );

  useEffect(() => {
    if (contentRef) {
      contentRef.addEventListener("animationend", invalidate);
    }
  }, [contentRef]);

  const modalStyles: Styles = useMemo(() => {
    return {
      content: {
        background: "transparent",
        padding: 0,
        border: "none",
        overflow: "none",
        display: "inline-block",
        position: "absolute",
        borderTopRightRadius: "25px",
        height: "100%",
        borderBottomRightRadius: "25px",
        "--contentWidth": contentRef?.clientWidth! * -1 + "px" || 0
        // zIndex: 1500,
      },
      overlay: {
        zIndex: 1500
      }
    };
  }, [contentRef]);

  useEffect(() => {
    if (sliderStatus === "default" && contentRef) {
      setSliderStatus("open");
    }
  }, [contentRef]);

  const leftSliderContent: LeftSliderType = useLeftSliderSelector();

  return (
    <Modal
      overlayRef={setOverlayRef}
      onRequestClose={closeLeftSlider}
      shouldCloseOnEsc
      shouldCloseOnOverlayClick
      contentRef={setContentRef}
      className={`left-slide--${sliderStatus}`}
      style={modalStyles}
      isOpen={!!leftSliderContent}
    >
      {leftSliderContent?.(closeLeftSlider)}
    </Modal>
  );
};
